import { useEffect, useState } from 'react';

const COOKIE_NAME = 'app_version';
const COOKIE_EXPIRY_DAYS = 365;

// Get cookie value
const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

// Set cookie
const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

const useCheckVersion = (shouldCheck = true) => {
    const [isNewVersion, setIsNewVersion] = useState(false);

    useEffect(() => {

        if (!shouldCheck) return; // ⛔ skip logic if not allowed

        const checkVersion = async () => {
            try {
                // Fetch version from version.json
                const res = await fetch('/version.json', { cache: 'no-cache' });
                const { version: currentVersion } = await res.json();

                const storedVersion = getCookie(COOKIE_NAME);


                if (!storedVersion) {
                    // First-time visitor or cookie expired
                    setCookie(COOKIE_NAME, currentVersion, COOKIE_EXPIRY_DAYS);
                } else if (String(storedVersion) !== String(currentVersion)) {
                    // Version mismatch
                    setCookie(COOKIE_NAME, currentVersion, COOKIE_EXPIRY_DAYS);
                    setIsNewVersion(true);
                }

            } catch (error) {
                console.error('Version check failed:', error);
            }
        };

        checkVersion();
    }, [shouldCheck]);

    return isNewVersion;
};

export default useCheckVersion;